export default class ReadUrlsByFavorites {
    #projectId;
    #orderBy;
    #sortBy;

    get projectId() { return this.#projectId; }
    set projectId(value) { this.#projectId = value; }
    get orderBy() { return this.#orderBy }
    set orderBy(value) { this.#orderBy = value }
    get sortBy() { return this.#sortBy }
    set sortBy(value) { this.#sortBy = value }


    static fromParams(projectId, meta) {

        const readUrlsByFavorites = new ReadUrlsByFavorites()
        readUrlsByFavorites.projectId = projectId
        readUrlsByFavorites.orderBy = meta.orderBy
        readUrlsByFavorites.sortBy = meta.sortBy

        return readUrlsByFavorites
    }

    toJson() {
        return {
            projectId: this.projectId,
            orderBy: this.orderBy,
            sortBy: this.sortBy,
        };
    }
}
